export const Video = () => {
  return (
    <iframe
      src="https://www.youtube.com/embed/X9F3eDN7jlA"
      title="YouTube video player"
      style={{
        width: '100%',
        height: '620px',
        borderRadius: '10px',
        border: 'none',
      }}
      className="video"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  );
};
